module.exports = __webpack_public_path__ + "img/8.db62d070.jpg";